var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "news-card",
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.news)
        },
      },
    },
    [
      _c("div", { staticClass: "news-card__date" }, [
        _c("span", { staticClass: "news-card__day" }, [
          _vm._v(_vm._s(_vm.dayStr)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "news-card__month" }, [
          _vm._v(_vm._s(_vm.monthStr)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "news-card__body" }, [
        _c("h3", { staticClass: "news-card__title" }, [
          _vm._v(_vm._s(_vm.newsTitle)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "news-card__summary" }, [
          _vm._v(_vm._s(_vm.newsSummary)),
        ]),
        _vm._v(" "),
        _vm.news.categoryLabel
          ? _c("span", { staticClass: "news-card__tag" }, [
              _vm._v(_vm._s(_vm.news.categoryLabel)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }